import type { TranslationDictionary } from '../types';

export const or: TranslationDictionary = {
  common: {
    appName: 'ApnaBlock',
    save: 'ସାଇତନ୍ତୁ',
    cancel: 'ବାତିଲ କରନ୍ତୁ',
    delete: 'ଡିଲିଟ୍ କରନ୍ତୁ',
    edit: 'ସମ୍ପାଦନ କରନ୍ତୁ',
    create: 'ତିଆରି କରନ୍ତୁ',
    back: 'ପଛକୁ ଫେରନ୍ତୁ',
    search: 'ଖୋଜନ୍ତୁ...',
    filter: 'ଫିଲ୍ଟର୍',
    refresh: 'ରିଫ୍ରେଶ୍',
    submit: 'ଦାଖଲ କରନ୍ତୁ',
    loading: 'ଲୋଡ୍ ହେଉଛି...',
    close: 'ବନ୍ଦ କରନ୍ତୁ',
    yes: 'ହଁ',
    no: 'ନାହିଁ',
    active: 'ସକ୍ରିୟ',
    inactive: 'ନିଷ୍କ୍ରିୟ',
    open: 'ଖୋଲା',
    pending: 'ବକେୟା / ବିଚାରାଧୀନ',
    approved: 'ଅନୁମୋଦିତ',
    rejected: 'ପ୍ରତ୍ୟାଖ୍ୟାନ',
    completed: 'ସମ୍ପୂର୍ଣ୍ଣ',
    inProgress: 'ଚାଲୁ ରହିଛି',
    resolved: 'ସମାଧାନ ହୋଇଛି',
    viewDetails: 'ବିବରଣୀ ଦେଖନ୍ତୁ',
    download: 'ଡାଉନଲୋଡ୍ କରନ୍ତୁ',
    print: 'ପ୍ରିଣ୍ଟ୍ କରନ୍ତୁ',
    export: 'ରପ୍ତାନି କରନ୍ତୁ',
    actions: 'କାର୍ଯ୍ୟ',
    status: 'ସ୍ଥିତି',
    date: 'ତାରିଖ',
    total: 'ମୋଟ',
    all: 'ସମସ୍ତ',
    reset: 'ରିସେଟ୍',
    more: 'ଅଧିକ',
    select: 'ବାଛନ୍ତୁ',
    language: 'ଭାଷା',
    selectLanguage: 'ଭାଷା ବାଛନ୍ତୁ',
    saveChanges: 'ପରିବର୍ତ୍ତନ ସାଇତନ୍ତୁ',
    savedSuccessfully: 'ସଫଳତାର ସହିତ ସାଇତାଗଲା',
    confirm: 'ନିଶ୍ଚିତ କରନ୍ତୁ',
    home: 'ମୂଳପୃଷ୍ଠା',
    favorites: 'ପସନ୍ଦ',
    pinned: 'ପିନ୍ ହୋଇଥିବା',
    tenant: 'ସୋସାଇଟି / ସମୁଦାୟ',
    openMenu: 'ମେନୁ ଖୋଲନ୍ତୁ',
    expandMenu: 'ମେନୁ ପ୍ରସାରଣ କରନ୍ତୁ',
    minimizeMenu: 'ମେନୁ ସଂକୁଚିତ କରନ୍ତୁ',
    lightMode: 'ଲାଇଟ୍ ମୋଡ୍',
    darkMode: 'ଡାର୍କ ମୋଡ୍',
    accountMenu: 'ଖାତା ମେନୁ',
    commandPalette: 'କମାଣ୍ଡ ପ୍ୟାଲେଟ୍',
    searchPages: 'ପୃଷ୍ଠା ଖୋଜନ୍ତୁ...',
    favorite: 'ପସନ୍ଦ',
    pin: 'ପିନ୍ କରନ୍ତୁ',
    calendar: 'କ୍ୟାଲେଣ୍ଡର',
    inbox: 'ଇନବକ୍ସ',
    ledger: 'ଖାତା ବହି',
    viewAll: 'ସବୁ ଦେଖନ୍ତୁ',
    platformNoSociety: 'ପ୍ଲାଟଫର୍ମ (କୌଣସି ସୋସାଇଟି ନାହିଁ)',
    noSociety: 'କୌଣସି ସୋସାଇଟି ନାହିଁ',
    trial: 'ଟ୍ରାଏଲ୍',
    expired: 'ମିଆଦ ପୂର୍ଣ୍ଣ',
    suspended: 'ସ୍ଥଗିତ',
    emptyTitle: 'ଏଠାରେ ଏପର୍ଯ୍ୟନ୍ତ କିଛି ନାହିଁ',
    emptyDescription: 'ବିବରଣୀ ଓ ଅପଡେଟ୍ ଉପଲବ୍ଧ ହେଲେ ଏଠାରେ ଦେଖାଯିବ।',
    tryAgain: 'ପୁନର୍ବାର ଚେଷ୍ଟା କରନ୍ତୁ',
    somethingWentWrong: 'କିଛି ତ୍ରୁଟି ଘଟିଛି',
    goBack: 'ପଛକୁ ଯାଆନ୍ତୁ',
    goToHome: 'ହୋମକୁ ଯାଆନ୍ତୁ',
    referenceId: 'ରେଫରେନ୍ସ ଆଇଡି',
    or: 'କିମ୍ବା',
  },
  auth: {
    login: 'ସାଇନ୍ ଇନ୍ କରନ୍ତୁ',
    logout: 'ଲଗ୍ ଆଉଟ୍',
    profile: 'ପ୍ରୋଫାଇଲ୍',
    email: 'ଇମେଲ୍ ଠିକଣା',
    password: 'ପାସୱାର୍ଡ',
    forgotPassword: 'ପାସୱାର୍ଡ ଭୁଲିଗଲେ କି?',
    sendOtp: 'ଓଟିପି ପଠାନ୍ତୁ',
    verifyOtp: 'ଓଟିପି ଯାଞ୍ଚ କରନ୍ତୁ',
    mobile: 'ମୋବାଇଲ୍ ନମ୍ବର',
    rememberMe: 'ମନେ ରଖନ୍ତୁ',
    biometricLogin: 'ବାୟୋମେଟ୍ରିକ୍ ଲଗଇନ୍',
    changePassword: 'ପାସୱାର୍ଡ ବଦଳାନ୍ତୁ',
    signOut: 'ସାଇନ୍ ଆଉଟ୍',
    welcome: 'ସ୍ଵାଗତ',
    signIn: 'ସାଇନ୍ ଇନ୍ କରନ୍ତୁ',
    signInSubtitle: 'ଆପଣଙ୍କର ସୋସାଇଟି କାର୍ଯ୍ୟକ୍ଷେତ୍ରକୁ ସୁରକ୍ଷିତ ଭାବେ ପ୍ରବେଶ କରନ୍ତୁ।',
    signingInTo: '{{name}} ରେ ସାଇନ୍ ଇନ୍ କରୁଛନ୍ତି',
    method: 'ପଦ୍ଧତି',
    emailTab: 'ଇମେଲ୍',
    mobileTab: 'ମୋବାଇଲ୍',
    otpTab: 'ଓଟିପି',
    emailLabel: 'ଇମେଲ୍ ଠିକଣା',
    mobileLabel: 'ମୋବାଇଲ୍ ନମ୍ବର',
    passwordLabel: 'ପାସୱାର୍ଡ',
    enableBiometricAfterLogin: 'ସାଇନ୍ ଇନ୍ ପରେ ବାୟୋମେଟ୍ରିକ୍ ଲଗଇନ୍ ସକ୍ଷମ କରନ୍ତୁ',
    signInWithBiometrics: 'ବାୟୋମେଟ୍ରିକ୍ସ ସହିତ ସାଇନ୍ ଇନ୍ କରନ୍ତୁ',
    verifyAndSignIn: 'ଯାଞ୍ଚ କରି ସାଇନ୍ ଇନ୍ କରନ୍ତୁ',
    changeIdentifier: 'ପରିଚୟ ବଦଳାନ୍ତୁ',
    enterOtpSentTo: 'ଆପଣଙ୍କର {{channel}} କୁ ପଠାଯାଇଥିବା ଓଟିପି ଦିଅନ୍ତୁ।',
    otpCodeLabel: 'ଓଟିପି କୋଡ୍',
    channelLabel: 'ମାଧ୍ୟମ',
    emailChannel: 'ଇମେଲ୍',
    smsChannel: 'ଏସଏମଏସ',
    forgotPasswordTitle: 'ପାସୱାର୍ଡ ଭୁଲିଗଲେ',
    forgotPasswordSubtitle: 'ଆପଣଙ୍କ ଇମେଲ୍ କିମ୍ବା ମୋବାଇଲ୍ ଦିଅନ୍ତୁ। ପାସୱାର୍ଡ ରିସେଟ୍ ପାଇଁ ଆମେ ଓଟିପି ପଠାଇବୁ।',
    emailOrMobile: 'ଇମେଲ୍ କିମ୍ବା ମୋବାଇଲ୍ ନମ୍ବର',
    backToSignIn: 'ସାଇନ୍ ଇନ୍ କୁ ଫେରନ୍ତୁ',
    resetPasswordTitle: 'ପାସୱାର୍ଡ ରିସେଟ୍ କରନ୍ତୁ',
    resetPasswordSubtitle: 'ଆପଣଙ୍କ ଇମେଲ୍ କିମ୍ବା ମୋବାଇଲ୍‌କୁ ପଠାଯାଇଥିବା ଓଟିପି ଦିଅନ୍ତୁ, ଏବଂ ନୂଆ ପାସୱାର୍ଡ ବାଛନ୍ତୁ।',
    newPasswordLabel: 'ନୂଆ ପାସୱାର୍ଡ',
    confirmPasswordLabel: 'ପାସୱାର୍ଡ ନିଶ୍ଚିତ କରନ୍ତୁ',
    updatePassword: 'ପାସୱାର୍ଡ ଅପଡେଟ୍ କରନ୍ତୁ',
    changePasswordTitle: 'ପାସୱାର୍ଡ ବଦଳାନ୍ତୁ',
    changePasswordSubtitle: 'ଆପଣଙ୍କର ଖାତା ପାସୱାର୍ଡ ଅପଡେଟ୍ କରନ୍ତୁ। ଆପଣ ସାଇନ୍ ଇନ୍ ରହିବେ।',
    currentPasswordLabel: 'ବର୍ତ୍ତମାନର ପାସୱାର୍ଡ',
    confirmNewPasswordLabel: 'ନୂଆ ପାସୱାର୍ଡ ନିଶ୍ଚିତ କରନ୍ତୁ',
    savePassword: 'ପାସୱାର୍ଡ ସାଇତନ୍ତୁ',
    passwordRequirementNotice: 'ଅତି କମରେ ୮ଟି ଅକ୍ଷର ବିଶିଷ୍ଟ ବଡ଼ ଅକ୍ଷର, ଛୋଟ ଅକ୍ଷର, ସଂଖ୍ୟା ଏବଂ ସ୍ୱତନ୍ତ୍ର ଅକ୍ଷର ବ୍ୟବହାର କରନ୍ତୁ।',
    bannerTagline: 'ଏଣ୍ଟରପ୍ରାଇଜ୍ ସୋସାଇଟି କାର୍ଯ୍ୟ — ବ୍ୟାଙ୍କିଙ୍ଗ୍, ଆଦାୟ, ବୈଠକ ଏବଂ ବାସିନ୍ଦା ଗୋଟିଏ ସ୍ଥାନରେ।',
    bannerSubtext: 'କଲୋନୀ ଏବଂ ହାଉସିଂ ସୋସାଇଟିଗୁଡ଼ିକ ପାଇଁ ସୁରକ୍ଷିତ ମଲ୍ଟି-ଟେନାଣ୍ଟ ପ୍ଲାଟଫର୍ମ।',
    biometricMobileOnly: 'ବାୟୋମେଟ୍ରିକ ଲଗଇନ କେବଳ ମୋବାଇଲ ଆପରେ ଉପଲବ୍ଧ।',
    biometricDesktopInfo: 'ବାୟୋମେଟ୍ରିକ ଲଗଇନ ApnaBlock ମୋବାଇଲ ଆପରେ ଉପଲବ୍ଧ।',
    signedInBiometrics: 'ବାୟୋମେଟ୍ରିକ୍ସ ସହିତ ସଫଳତାର ସହିତ ସାଇନ୍ ଇନ୍ ହେଲା',
    biometricSessionExpired: 'ଅଧିବେଶନ ସମାପ୍ତ କିମ୍ବା ବାତିଲ ହୋଇଛି। ଦୟାକରି ଆପଣଙ୍କର ପାସୱାର୍ଡ ସହିତ ସାଇନ୍ ଇନ୍ କରନ୍ତୁ।',
    biometricAuthFailed: 'ବାୟୋମେଟ୍ରିକ୍ ପ୍ରମାଣୀକରଣ ବିଫଳ ହେଲା। ଦୟାକରି ପାସୱାର୍ଡ ବ୍ୟବହାର କରନ୍ତୁ।',
    biometricEnrollSuccess: 'ବାୟୋମେଟ୍ରିକ୍ ଲଗଇନ୍ ସକ୍ଷମ ହୋଇଛି',
    biometricEnrollCancelled: 'ବାୟୋମେଟ୍ରିକ୍ ନାମାଙ୍କନ ବାତିଲ ହେଲା। ସାଧାରଣ ଲଗଇନ୍ ସଫଳ ହେଲା।',
    welcomeMarketing: 'ମାର୍କେଟିଂ ପାର୍ଟନର ପୋର୍ଟାଲକୁ ସ୍ୱାଗତ',
    welcomePlatform: 'ପ୍ଲାଟଫର୍ମ ପ୍ରଶାସନକୁ ସ୍ୱାଗତ',
    welcomeBackToast: 'ପୁନର୍ବାର ସ୍ୱାଗତ',
    otpSentSuccess: 'OTP ସଫଳତାର ସହିତ ପଠାଗଲା',
    otpVerifyFailed: 'OTP ଯାଞ୍ଚ ବିଫଳ ହେଲା',
    loginFailed: 'ଲଗଇନ୍ ବିଫଳ ହେଲା',
    biometricAuthReason: 'ApnaBlock ରେ ସାଇନ୍ ଇନ୍ କରିବା ପାଇଁ ଆପଣଙ୍କ ପରିଚୟ ଯାଞ୍ଚ କରନ୍ତୁ',
    biometricAvailableFor: '{{identifier}} ପାଇଁ ବାୟୋମେଟ୍ରିକ୍ ଲଗଇନ୍ ଉପଲବ୍ଧ',
    biometricEnrollPrompt: '{{name}} ପାଇଁ ବାୟୋମେଟ୍ରିକ୍ ଲଗଇନ୍ ସକ୍ଷମ କରିବେ କି?',
  },
  nav: {
    dashboard: 'ଡ୍ୟାସବୋର୍ଡ',
    society: 'ସୋସାଇଟି',
    societySettings: 'ମୋର ସୋସାଇଟି',
    societyBlocks: 'ବ୍ଲକ୍ / ଟାୱାର୍',
    societyHouses: 'ଘର / ଫ୍ଲାଟ୍',
    societyResidents: 'ବାସିନ୍ଦା',
    societyStaff: 'କର୍ମଚାରୀ',
    imports: 'ତଥ୍ୟ ଆମଦାନୀ',
    finance: 'ଆର୍ଥିକ ଓ ହିସାବ',
    financePayments: 'ମୋର ଦେୟ',
    financeCollections: 'ଆଦାୟ',
    financeSocietyFund: 'ସୋସାଇଟି ପାଣ୍ଠି',
    financeSpecialCollections: 'ସ୍ୱତନ୍ତ୍ର ଆଦାୟ',
    financeCorpusFund: 'କର୍ପସ ଫଣ୍ଡ',
    financeExpenses: 'ଖର୍ଚ୍ଚ',
    financeExpenseGroups: 'ଖର୍ଚ୍ଚ ଗୋଷ୍ଠୀ',
    financeWaterTanker: 'ପାଣି ଟ୍ୟାଙ୍କର୍',
    financeReimbursements: 'ପ୍ରତିପୂର୍ତ୍ତି ଦାବି',
    financeBanking: 'ବ୍ୟାଙ୍କ ଖାତା',
    financeStatements: 'ଷ୍ଟେଟମେଣ୍ଟ ଓ ରସିଦ',
    financeReports: 'ଆର୍ଥିକ ରିପୋର୍ଟ',
    financeReconciliation: 'ଦେୟ ସମନ୍ୱୟ',
    security: 'ସୁରକ୍ଷା ଓ ଗେଟ୍',
    gatePasses: 'ଗେଟ୍ ପାସ୍',
    securityDashboard: 'ସୁରକ୍ଷା ଡ୍ୟାସବୋର୍ଡ',
    securityGates: 'ଗେଟ୍ ପରିଚାଳନା',
    securityShifts: 'ଗାର୍ଡ ସିଫ୍ଟ ରିପୋର୍ଟ',
    securityPolicies: 'ସୁରକ୍ଷା ନୀତି',
    securityDeskPortal: 'ସୁରକ୍ଷା ଗେଟ୍ ଡେସ୍କ',
    visitors: 'ଦର୍ଶକ ଡେସ୍କ',
    securityCameras: 'ସିସିଟିଭି କ୍ୟାମେରା',
    community: 'ସମୁଦାୟ ଓ ସମ୍ପର୍କ',
    notices: 'ବିଜ୍ଞପ୍ତି',
    communityForum: 'ସାମୂହିକ ମଞ୍ଚ',
    events: 'କାର୍ଯ୍ୟକ୍ରମ',
    eventsList: 'କାର୍ଯ୍ୟକ୍ରମ',
    eventsCalendar: 'କାର୍ଯ୍ୟକ୍ରମ କ୍ୟାଲେଣ୍ଡର',
    invitations: 'ନିମନ୍ତ୍ରଣ ଓ ପ୍ରତିକ୍ରିୟା',
    whatsapp: 'ହ୍ୱାଟ୍ସଆପ୍ ଲଗ୍',
    notifications: 'ବିଜ୍ଞପ୍ତିଗୁଡ଼ିକ',
    operations: 'କାର୍ଯ୍ୟକ୍ଷମତା ଓ ସହାୟତା',
    complaints: 'ଅଭିଯୋଗ',
    serviceRequests: 'ସେବା ଅନୁରୋଧ',
    serviceDirectory: 'ସେବା ଡାଇରେକ୍ଟରୀ',
    amenities: 'ସୁବିଧା ସୁଯୋଗ',
    meetings: 'ବୈଠକ',
    documents: 'ଦସ୍ତାବିଜ୍ ଭଣ୍ଡାର',
    governance: 'ଶାସନ ଓ ନିର୍ବାଚନ',
    polls: 'ବାସିନ୍ଦା ମତାମତ',
    elections: 'ନିର୍ବାଚନ',
    governancePetitions: 'ଦରଖାସ୍ତ ଦାଖଲ କରନ୍ତୁ',
    governanceResignation: 'ଇସ୍ତଫା ଦାଖଲ କରନ୍ତୁ',
    administration: 'ପ୍ରଶାସନ',
    adminLicense: 'ଲାଇସେନ୍ସ',
    adminInvoices: 'ସଦସ୍ୟତା ବିଲ୍',
    adminRoles: 'ଭୂମିକା ଓ ଅନୁମତି',
    adminLetterhead: 'ଲେଟରହେଡ୍ ଓ ବ୍ରାଣ୍ଡିଂ',
    adminIntegrations: 'ଏସଏମଏସ ଓ ହ୍ୱାଟ୍ସଆପ୍',
    adminAiConfig: 'ଏଆଇ ବିନ୍ୟାସ',
    adminNavigation: 'ମେନୁ କଷ୍ଟମାଇଜେସନ୍',
    adminAudit: 'ଅଡିଟ୍ ଲଗ୍',
    documentationGroup: 'ସହାୟତା ଓ ଦସ୍ତାବିଜ୍',
    societySupportDesk: 'ସହାୟତା ଓ ସମର୍ଥନ',
    docsKnowledgeBase: 'ଜ୍ଞାନ କେନ୍ଦ୍ର',
    docsRoleMatrix: 'ଭୂମିକା ଓ ଅନୁମତି ମ୍ୟାଟ୍ରିକ୍ସ',
    docsQaHub: 'କ୍ୟୁଏ ଟେଷ୍ଟ ହବ୍',
    docsTestExplorer: 'ଟେଷ୍ଟ କେସ୍ ଏକ୍ସପ୍ଲୋରର୍',
    licenseLocked: 'ଲାଇସେନ୍ସ',
    platformSocietiesGroup: 'ସୋସାଇଟି ଓ ଟେନାଣ୍ଟ',
    platformSocieties: 'ସମସ୍ତ ସୋସାଇଟି',
    platformSocietiesNew: 'ସୋସାଇଟି ପଞ୍ଜୀକରଣ କରନ୍ତୁ',
    platformSocietyTypes: 'ସୋସାଇଟି ପ୍ରକାର ଓ ବର୍ଗୀକରଣ',
    platformTrials: 'ମାଗଣା ପରୀକ୍ଷଣ',
    platformSubscriptions: 'ସଦସ୍ୟତା',
    platformLicenses: 'ସଫ୍ଟୱେୟାର ଲାଇସେନ୍ସ',
    platformPlans: 'ସଦସ୍ୟତା ଯୋଜନା',
    platformInvoices: 'ବିଲିଂ ଓ ଇନଭଏସ୍',
    platformPricingOverrides: 'ମୂଲ୍ୟ ନିର୍ଦ୍ଧାରଣ ପରିବର୍ତ୍ତନ',
    platformCoupons: 'କୁପନ୍ ଓ ରିହାତି',
    platformPromotionGroup: 'ପ୍ରଗତି ଓ ପ୍ରଚାର',
    platformPromotionDashboard: 'ପ୍ରଗତି ଡ୍ୟାସବୋର୍ଡ',
    platformPromotionProspects: 'ସମ୍ଭାବ୍ୟ ଗ୍ରାହକ',
    platformPromotionCampaigns: 'ଅଭିଯାନ',
    platformPromotionTemplates: 'ବାର୍ତ୍ତା ଟେମ୍ପଲେଟ୍',
    platformPromotionSenderProfiles: 'ପ୍ରେରକ ପ୍ରୋଫାଇଲ୍',
    platformPromotionEmail: 'ଇମେଲ୍ ମାର୍କେଟିଂ',
    platformPromotionWhatsapp: 'ହ୍ୱାଟ୍ସଆପ୍ ପ୍ରସାରଣ',
    platformPromotionSms: 'ଏସଏମଏସ ମାର୍କେଟିଂ',
    platformPromotionOther: 'ଅନ୍ୟାନ୍ୟ ମାଧ୍ୟମ',
    platformReferrals: 'ରେଫରାଲ୍ ଓ ସହଯୋଗୀ',
    platformMarketing: 'ମାର୍କେଟିଂ କର୍ମଚାରୀ',
    platformPromotionAnalytics: 'ପ୍ରଚାର ବିଶ୍ଳେଷଣ',
    platformPromotionSettings: 'ମାର୍କେଟିଂ ସେଟିଙ୍ଗ୍',
    platformManagementGroup: 'ପ୍ଲାଟଫର୍ମ ଓ ସମର୍ଥନ',
    platformWebsite: 'ୱେବସାଇଟ୍ ସିଏମଏସ୍ ଓ ବ୍ରାଣ୍ଡିଂ',
    platformSupportTickets: 'ସହାୟତା ଟିକେଟ୍ ଡେସ୍କ',
    platformFeatureRequests: 'ସୁବିଧା ଅନୁରୋଧ',
    platformFeatures: 'ଫିଚର୍ ଫ୍ଲାଗ୍',
    platformUsers: 'ପ୍ଲାଟଫର୍ମ ପ୍ରଶାସକ',
    platformCoverageAudit: 'ଦସ୍ତାବିଜ୍ କଭରେଜ୍ ଅଡିଟ୍',
    platformReportsGroup: 'ବିଶ୍ଳେଷଣ ଓ ରିପୋର୍ଟ',
    platformAnalytics: 'ପ୍ଲାଟଫର୍ମ ବିଶ୍ଳେଷଣ',
    platformSystemGroup: 'ସିଷ୍ଟମ୍ ଓ ସୁରକ୍ଷା',
    platformSystemHealth: 'ସିଷ୍ଟମ୍ ସ୍ୱାସ୍ଥ୍ୟ',
    platformAuditLogs: 'ଅଡିଟ୍ ଲଗ୍',
    platformNotifications: 'ସତର୍କତା ଓ ବିଜ୍ଞପ୍ତି',
    platformSettings: 'ଗ୍ଲୋବାଲ୍ ସେଟିଙ୍ଗ୍',
    platformDataCleanup: 'ତଥ୍ୟ ସଫା କରିବା',
    platformGoogleCalendar: 'ଗୁଗଲ୍ କ୍ୟାଲେଣ୍ଡର ସଂଯୋଗ',
    platformMaintenance: 'ଡାଟାବେସ୍ ରକ୍ଷଣାବେକ୍ଷଣ',
    directory: 'ବାସିନ୍ଦା ଡାଇରେକ୍ଟରୀ',
    members: 'ସଦସ୍ୟ',
    houses: 'ୟୁନିଟ୍ ଓ ଫ୍ଲାଟ୍',
    settings: 'ସେଟିଙ୍ଗ୍ସ',
    myUnit: 'ମୋର ୟୁନିଟ୍',
    waterTankers: 'ପାଣି ଟ୍ୟାଙ୍କର୍',
    patrol: 'ଗାର୍ଡ ପାଟ୍ରୋଲିଂ',
    cameras: 'ଲାଇଭ୍ ସିସିଟିଭି',
    marketplace: 'ମାର୍କେଟପ୍ଲେସ୍',
    profile: 'ମୋର ପ୍ରୋଫାଇଲ୍',
    superAdmin: 'ପ୍ଲାଟଫର୍ମ ଆଡମିନ୍',
    staff: 'ସୋସାଇଟି କର୍ମଚାରୀ',
    helpDesk: 'ହେଲ୍ପଡେସ୍କ',
    favorites: 'ପସନ୍ଦ',
    pinned: 'ପିନ୍ ହୋଇଥିବା',
    navGroupHome: 'ହୋମ୍',
    navGroupSociety: 'ମୋ ସୋସାଇଟି',
    navGroupMoney: 'ଅର୍ଥ ଓ ଦେୟ',
    navGroupSecurity: 'ସୁରକ୍ଷା ଓ ଗେଟ୍',
    navGroupCommunity: 'ସମୁଦାୟ',
    navGroupManagement: 'ପରିଚାଳନା',
    navGroupAdmin: 'ପ୍ରଶାସନ',
    navGroupHelp: 'ସହାୟତା ଓ ଦସ୍ତାବିଜ',
    securityNotificationSettings: 'ସୁରକ୍ଷା ନିୟମାବଳୀ',
    securityCcCameras: 'ସିସିଟିଭି କ୍ୟାମେରା',
  },
  mobile: {
    greetingMorning: 'ଶୁଭ ସକାଳ, {{name}}',
    greetingAfternoon: 'ଶୁଭ ଅପରାହ୍ନ, {{name}}',
    greetingEvening: 'ଶୁଭ ସନ୍ଧ୍ୟା, {{name}}',
    greetingNight: 'ଶୁଭ ରାତ୍ରି, {{name}}',
    greetingGeneric: 'ସ୍ୱାଗତମ୍, {{name}}',
    priorityAttention: 'ଧ୍ୟାନ ଦେବା ଯୋଗ୍ୟ',
    priorityAllClear: 'ସମସ୍ତ ଦେୟ ପରିଶୋଧ ହୋଇଛି',
    priorityAllClearSub: 'କୌଣସି ବକେୟା ମେଣ୍ଟେନାନ୍ସ ନାହିଁ',
    payMaintenance: 'ମେଣ୍ଟେନାନ୍ସ ପ୍ରଦାନ କରନ୍ତୁ',
    payDues: 'ବର୍ତ୍ତମାନ ଦିଅନ୍ତୁ',
    viewDues: 'ବକେୟା ଦେଖନ୍ତୁ',
    viewReceipt: 'ରସିଦ୍ ଦେଖନ୍ତୁ',
    dueBy: 'ଦେୟ ତାରିଖ {{date}}',
    quickActions: 'ତୁରନ୍ତ କାର୍ଯ୍ୟ',
    actionPay: 'ଦେୟ ପ୍ରଦାନ',
    actionVisitors: 'ଅତିଥି',
    actionRaiseIssue: 'ଅଭିଯୋଗ ଦାଖଲ',
    actionNotices: 'ନୋଟିସ୍ ବୋର୍ଡ',
    actionBookFacility: 'ସୁବିଧା ବୁକ୍ କରନ୍ତୁ',
    actionEmergency: 'ଜରୁରୀକାଳୀନ SOS',
    actionDirectory: 'ଡିରେକ୍ଟୋରି',
    actionPolls: 'ଭୋଟିଂ ଓ ପୋଲ୍',
    actionMeetings: 'ବୈଠକ',
    societyUpdates: 'ସୋସାଇଟି ଅପଡେଟ୍',
    gateAndVisitors: 'ଗେଟ୍ ଓ ଅତିଥି',
    upcomingEvents: 'ଆଗାମୀ କାର୍ଯ୍ୟକ୍ରମ',
    maintenanceAndReceipts: 'ମେଣ୍ଟେନାନ୍ସ ଓ ରସିଦ୍',
    pendingApprovals: 'ବକେୟା ମଞ୍ଜୁରୀ',
    collectionsOverview: 'ଆଦାୟ ସଂକ୍ଷେପ',
    pendingReview: 'ସମୀକ୍ଷା ବାକି',
    noPendingReviews: 'ସମସ୍ତ ସମୀକ୍ଷା ସମ୍ପୂର୍ଣ୍ଣ',
    totalCollected: 'ମୋଟ ଆଦାୟ',
    totalOutstanding: 'ମୋଟ ବକେୟା',
    activeGatePasses: 'ସକ୍ରିୟ ଗେଟ୍ ପାସ୍',
    noVisitorsToday: 'ଆଜି କୌଣସି ଅତିଥି ଆସିନାହାଁନ୍ତି',
    noActivePasses: 'କୌଣସି ସକ୍ରିୟ ପାସ୍ ନାହିଁ',
    preApproveGuest: 'ଅତିଥି ପୂର୍ବ-ମଞ୍ଜୁରୀ',
    recentReceipts: 'ନିକଟତମ ରସିଦ୍',
    noRecentReceipts: 'କୌଣସି ନିକଟତମ କାରବାର ନାହିଁ',
    managementDesk: 'ପରିଚାଳନା ଡେସ୍କ',
    switchRole: 'ଦୃଶ୍ୟ ବଦଳାନ୍ତୁ',
    residentView: 'ନିବାସୀ ଦୃଶ୍ୟ',
    committeeView: 'କମିଟି ଦୃଶ୍ୟ',
    emergencyModalTitle: 'ଜରୁରୀକାଳୀନ SOS ସତର୍କତା',
    emergencyModalSubtitle: 'ସୁରକ୍ଷା ଗାର୍ଡ ଏବଂ ସୋସାଇଟି କମିଟିକୁ ତୁରନ୍ତ ସଙ୍କେତ ପଠାନ୍ତୁ',
    tapToCall: 'ଗାର୍ଡଙ୍କୁ କଲ୍ କରନ୍ତୁ',
    tapToWhatsApp: 'କାର୍ଯ୍ୟାଳୟ ହ୍ୱାଟ୍ସଆପ୍',
    pullToRefresh: 'ରିଫ୍ରେଶ୍ କରିବା ପାଇଁ ତଳକୁ ଟାଣନ୍ତୁ',
    refreshing: 'ରିଫ୍ରେଶ୍ ହେଉଛି…',
    noMeetingsScheduled: 'କୌଣସି ବୈଠକ ନାହିଁ',
    noNoticesPublished: 'କୌଣସି ସୂଚନା ପ୍ରକାଶିତ ହୋଇନାହିଁ',
    noUpcomingEvents: 'କୌଣସି ଆଗାମୀ କାର୍ଯ୍ୟକ୍ରମ ନାହିଁ',
    viewAllNotices: 'ସମସ୍ତ ନୋଟିସ୍ ଦେଖନ୍ତୁ',
    viewAllEvents: 'ସମସ୍ତ କାର୍ଯ୍ୟକ୍ରମ ଦେଖନ୍ତୁ',
    viewAllComplaints: 'ସମସ୍ତ ଅଭିଯୋଗ ଦେଖନ୍ତୁ',
    sectionDiscover: 'ଆବିଷ୍କାର କରନ୍ତୁ',
    sectionEngage: 'ଯୋଗଦାନ କରନ୍ତୁ',
    sectionPay: 'ପୈଠ କରନ୍ତୁ',
    cardResidents: 'ବାସିନ୍ଦା',
    cardResidentsDesc: 'ଆପଣଙ୍କ ସୋସାଇଟିର ଲୋକଙ୍କୁ ଖୋଜନ୍ତୁ',
    cardLocalHelp: 'ସ୍ଥାନୀୟ ସାହାଯ୍ୟ',
    cardLocalHelpDesc: 'ଦୈନନ୍ଦିନ ଘରୋଇ ସହାୟତା ଖୋଜନ୍ତୁ',
    cardEmergencyContacts: 'ଜରୁରୀକାଳୀନ ଯୋଗାଯୋଗ',
    cardEmergencyContactsDesc: 'ପୋଲିସ୍, ଆମ୍ବୁଲାନ୍ସ ଏବଂ ଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ ନମ୍ବର',
    cardHelpDesk: 'ସାହାଯ୍ୟ ଏବଂ ଅଭିଯୋଗ',
    cardHelpDeskDesc: 'ସମସ୍ୟା ଦାଖଲ କରନ୍ତୁ କିମ୍ବା ସାହାଯ୍ୟ ମାଗନ୍ତୁ',
    cardFacilities: 'ସୁବିଧାସୁଯୋଗ',
    cardFacilitiesDesc: 'ସୋସାଇଟି ସୁବିଧା ବୁକ୍ କରନ୍ତୁ',
    cardNotices: 'ସୋସାଇଟି ନୋଟିସ୍',
    cardNoticesDesc: 'ସୋସାଇଟିରୁ ଜରୁରୀ ସୂଚନା',
    cardCommunity: 'କମ୍ୟୁନିଟି',
    cardCommunityDesc: 'ପୋଲ୍, ବୈଠକ ଏବଂ କାର୍ଯ୍ୟକ୍ରମ',
    cardDocuments: 'ଦଲିଲପତ୍ର',
    cardDocumentsDesc: 'ସୋସାଇଟି ଏବଂ ବ୍ୟକ୍ତିଗତ ଦସ୍ତାବେଜ୍',
    cardPaymentsDues: 'ପୈଠ ଏବଂ ବକେୟା',
    cardPaymentsDuesDesc: 'ବକେୟା ଦେଖନ୍ତୁ ଏବଂ ପୈଠ କରନ୍ତୁ',
    cardUtilities: 'ୟୁଟିଲିଟି',
    cardUtilitiesDesc: 'ବିଦ୍ୟୁତ୍, ଜଳ ଏବଂ ଅନ୍ୟାନ୍ୟ ସେବା',
    actionRequired: 'ଧ୍ୟାନ ଦେବା ଯୋଗ୍ୟ',
    pendingActionSubtitle: '{{count}} ଟି ବିଷୟ କମିଟି ସମୀକ୍ଷା ପାଇଁ ବାକି ଅଛି',
    collectionsStatus: 'ଆଦାୟ ଏବଂ ବକେୟା',
    uncollectedSocietyDues: '{{count}} ଟି ବକେୟା ପୈଠ',
    collectedThisMonth: 'ଏହି ମାସର ମୋଟ ଆଦାୟ',
    viewLedger: 'ଖାତା ଦେଖନ୍ତୁ',
    committeeActions: 'କମିଟି କାର୍ଯ୍ୟାନୁଷ୍ଠାନ',
    postNotice: 'ନୋଟିସ୍ ଜାରି କରନ୍ତୁ',
    postNoticeDesc: 'ସୋସାଇଟିକୁ ସୂଚନା ପଠାନ୍ତୁ',
    addExpense: 'ଖର୍ଚ୍ଚ ଯୋଡ଼ନ୍ତୁ',
    addExpenseDesc: 'ସୋସାଇଟି ଖର୍ଚ୍ଚ ଲେଖନ୍ତୁ',
    scheduleMeeting: 'ବୈଠକ ସ୍ଥିର କରନ୍ତୁ',
    scheduleMeetingDesc: 'କମିଟି ବୈଠକ ଆୟୋଜନ କରନ୍ତୁ',
    residentDirectory: 'ବାସିନ୍ଦା ଡିରେକ୍ଟୋରୀ',
    residentDirectoryDesc: 'ବାସିନ୍ଦାଙ୍କୁ ଖୋଜନ୍ତୁ ଏବଂ ଯୋଗାଯୋଗ କରନ୍ତୁ',
    complaintsOverview: 'ଅଭିଯୋଗ ଏବଂ ହେଲ୍ପଡେସ୍କ',
    upcomingMeetingsCount: '{{count}} ଟି ଆଗାମୀ ବୈଠକ',
    viewMeetingAgenda: 'ବୈଠକ ବିବରଣୀ ଏବଂ ଏଜେଣ୍ଡା ଦେଖନ୍ତୁ',
    resignOfficeTitle: 'ଇସ୍ତଫା ଦାଖଲ କରନ୍ତୁ',
    resignOfficeNotice: 'ସୋସାଇଟି ସଦସ୍ୟମାନଙ୍କୁ ଆନୁଷ୍ଠାନିକ ଇସ୍ତଫା ଦାଖଲ କରନ୍ତୁ',
    activeSocietyElections: 'ସକ୍ରିୟ ସୋସାଇଟି ନିର୍ବାଚନ',
    votingLiveStatus: 'ସଦସ୍ୟମାନଙ୍କ ପାଇଁ ଭୋଟିଂ ଜାରି ରହିଛି',
    castYourVotePrompt: 'ମନୋନୀତ କମିଟି ପ୍ରାର୍ଥୀଙ୍କୁ ଆପଣଙ୍କ ଭୋଟ୍ ଦିଅନ୍ତୁ',
    recentNotices: 'ସାମ୍ପ୍ରତିକ ନୋଟିସ୍',
    myComplaints: 'ମୋର ଅଭିଯୋଗ',
    noActiveComplaints: 'କୌଣସି ସକ୍ରିୟ ଅଭିଯୋଗ କିମ୍ବା ଟିକେଟ୍ ନାହିଁ',
  },
  profile: {
    profileTitle: 'ପ୍ରୋଫାଇଲ୍ ଓ ପସନ୍ଦ',
    profileSubtitle: 'ଆପଣଙ୍କର ବ୍ୟକ୍ତିଗତ ବିବରଣୀ, ସୁରକ୍ଷା ଏବଂ ଆପ୍ ଭାଷା ପରିଚାଳନା କରନ୍ତୁ।',
    basicDetails: 'ମୌଳିକ ବିବରଣୀ',
    firstName: 'ପ୍ରଥମ ନାମ',
    lastName: 'ଶେଷ ନାମ',
    email: 'ଇମେଲ୍',
    mobile: 'ମୋବାଇଲ୍ ନମ୍ବର',
    saveDetails: 'ବିବରଣୀ ସାଇତନ୍ତୁ',
    userId: 'ୟୁଜର୍ ଆଇଡି',
    roles: 'ନିର୍ଦ୍ଧାରିତ ଭୂମିକା',
    tenant: 'ସୋସାଇଟି / ସମୁଦାୟ',
    securityBiometrics: 'ସୁରକ୍ଷା ଏବଂ ବାୟୋମେଟ୍ରିକ୍ସ',
    securityBiometricsDesc: 'ଫିଙ୍ଗରପ୍ରିଣ୍ଟ କିମ୍ବା ଫେସ୍ ଆଇଡି ମାଧ୍ୟମରେ ଆପ୍ କୁ ସହଜରେ ଖୋଲନ୍ତୁ।',
    biometricLoginEnabled: 'ବାୟୋମେଟ୍ରିକ୍ ଲଗଇନ୍ ସକ୍ରିୟ ଅଛି',
    enableBiometricLogin: 'ବାୟୋମେଟ୍ରିକ୍ ଲଗଇନ୍ ସକ୍ଷମ କରନ୍ତୁ',
    notificationPreferences: 'ବିଜ୍ଞପ୍ତି ପସନ୍ଦ',
    notificationPreferencesDesc: 'ଆପଣ ନୋଟିସ୍ ଏବଂ ଆଲର୍ଟ କିପରି ପାଇବେ ତାହା ନିୟନ୍ତ୍ରଣ କରନ୍ତୁ।',
    languagePreferences: 'ଆପ୍ ଭାଷା',
    languagePreferencesDesc: 'ଆପଣଙ୍କର ଡିଫଲ୍ଟ ଭାଷା ବାଛନ୍ତୁ। ଆପ୍ ସର୍ବଦା ଏହି ଭାଷାରେ ଖୋଲିବ।',
    currentLanguage: 'ବର୍ତ୍ତମାନର ଭାଷା',
    selectDefaultLanguage: 'ଡିଫଲ୍ଟ ଭାଷା ବାଛନ୍ତୁ',
    defaultLanguageNotice: 'ଆପଣଙ୍କ ମନୋନୀତ ଭାଷା ସଂରକ୍ଷିତ ହୋଇଛି ଏବଂ ପ୍ରତ୍ୟେକ ଥର ଖୋଲିବା ବେଳେ ଲାଗୁ ହେବ।',
    saveLanguage: 'ଡିଫଲ୍ଟ ଭାଷା ଭାବେ ସେଟ୍ କରନ୍ତୁ',
    languageUpdated: 'ଭାଷା ପସନ୍ଦ ସଫଳତାର ସହିତ ସାଇତାଗଲା',
  },
  dashboard: {
    welcomeBack: 'ସ୍ୱାଗତମ',
    welcomeBackUser: 'ସ୍ୱାଗତମ, {{name}}',
    societyWorkspace: 'ଆପଣଙ୍କର ସୋସାଇଟି କାର୍ଯ୍ୟକ୍ଷେତ୍ର',
    platformSubtitle: 'ବ୍ୟୋରା ପ୍ଲାଟଫର୍ମ · ସୋସାଇଟି ଏବଂ ସଫ୍ଟୱେୟାର ଲାଇସେନ୍ସ',
    registerSociety: 'ସୋସାଇଟି ପଞ୍ଜୀକରଣ କରନ୍ତୁ',
    registerSocietyHint: 'ଟେନାଣ୍ଟ ଏବଂ ସଭାପତି ଲଗଇନ୍ ତିଆରି କରନ୍ତୁ',
    allSocieties: 'ସମସ୍ତ ସୋସାଇଟି',
    allSocietiesHint: 'ତାଲିକା ଏବଂ ସ୍ଥିତି',
    softwareLicenses: 'ସଫ୍ଟୱେୟାର ଲାଇସେନ୍ସ',
    softwareLicensesHint: 'ସୋସାଇଟି ବାଛନ୍ତୁ, ଲାଇସେନ୍ସ ପ୍ରଦାନ ବା ସମୀକ୍ଷା କରନ୍ତୁ',
    bankBalance: 'ବ୍ୟାଙ୍କ ବାଲାନ୍ସ',
    outstandingDues: 'ବକେୟା ଦେୟ',
    residents: 'ବାସିନ୍ଦା',
    openRequests: 'ଖୋଲା ଅନୁରୋଧ',
    upcomingMeetings: 'ଆଗାମୀ ବୈଠକ',
    platform: 'ପ୍ଲାଟଫର୍ମ',
    societies: 'ସୋସାଇଟିଗୁଡ଼ିକ',
    licenses: 'ଲାଇସେନ୍ସଗୁଡ଼ିକ',
    noBankAccounts: 'ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି ବ୍ୟାଙ୍କ ଖାତା ନାହିଁ',
    allDuesCleared: 'ସମସ୍ତ ବକେୟା ପରିଶୋଧ ହୋଇଛି',
    noOpenComplaints: 'କୌଣସି ଖୋଲା ଅଭିଯୋଗ ନାହିଁ',
    noMeetingsScheduled: 'କୌଣସି ବୈଠକ ନିର୍ଦ୍ଧାରିତ ହୋଇନାହିଁ',
    overdueAndOpen: '{{overdue}} ଅତିକ୍ରାନ୍ତ · {{open}} ଖୋଲା ବିଲ୍',
    openBillsCount: '{{count}} ଖୋଲା ବିଲ୍',
    openBillsCountSingle: '୧ ଖୋଲା ବିଲ୍',
    accountsCountThisMonth: '{{count}} ଖାତା · ଚଳିତ ମାସ {{amount}} ଆସିଛି',
    accountsCountThisMonthSingle: '୧ ଖାତା · ଏହି ମାସରେ {{amount}} ଜମା',
    residentsAndHouses: '{{residents}} ବାସିନ୍ଦା · {{houses}} ଘର',
    residentsOnRecord: '{{count}} ରେକର୍ଡରେ ଅଛନ୍ତି',
    housesCount: '{{count}} ଘର',
    pendingReviewOverdue: '{{pending}} ସମୀକ୍ଷାଧୀନ · {{overdue}} ଅତିକ୍ରାନ୍ତ',
    pendingReview: '{{count}} ସମୀକ୍ଷାଧୀନ',
    statManage: 'ପରିଚାଳନା',
    statSubscription: 'ସଦସ୍ୟତା',
    collectionsCashflow: 'ଆଦାୟ ଓ ନଗଦ ପ୍ରବାହ',
    collected: 'ଆଦାୟ ହୋଇଥିବା',
    outstanding: 'ବକେୟା ଥିବା',
    thisMonthCashflow: 'ଏହି ମାସ · ଆଗମନ {{credit}} / ଖର୍ଚ୍ଚ {{debit}}',
    cashflow: 'ନଗଦ ପ୍ରବାହ',
    quickActions: 'ତ୍ୱରିତ କାର୍ଯ୍ୟ',
    scheduleMeeting: 'ବୈଠକ ଧାର୍ଯ୍ୟ କରନ୍ତୁ',
    scheduleMeetingHint: 'ମାଲିକ ଓ କ୍ୟାଲେଣ୍ଡରକୁ ସୂଚନା ଦିଅନ୍ତୁ',
    postNotice: 'ନୋଟିସ୍ ଜାରି କରନ୍ତୁ',
    postNoticeHint: 'ସୋସାଇଟିକୁ ଘୋଷଣା କରନ୍ତୁ',
    raiseComplaint: 'ଅଭିଯୋଗ ଦାଖଲ କରନ୍ତୁ',
    raiseComplaintHint: 'ସେବା ଅନୁରୋଧ ଲଗ୍ କରନ୍ତୁ',
    filePetition: 'ଦରଖାସ୍ତ ଦାଖଲ କରନ୍ତୁ',
    filePetitionHint: 'ଇସ୍ତଫା ଦାବି ବା କାର୍ଯ୍ୟାନୁଷ୍ଠାନ',
    viewProfile: 'ପ୍ରୋଫାଇଲ୍ ଦେଖନ୍ତୁ',
    viewProfileHint: 'ଖାତା ଓ ଅନୁମତି',
    publicPetitions: 'ସର୍ବସାଧାରଣ ଦରଖାସ୍ତ',
    openPetitions: 'ଖୋଲା ଦରଖାସ୍ତ · ସମସ୍ତ ସଦସ୍ୟଙ୍କ ପାଇଁ ଦୃଶ୍ୟମାନ',
    openBoard: 'ବୋର୍ଡ ଖୋଲନ୍ତୁ',
    noMeetingsDescription: 'ଆଗାମୀ କମିଟି ବୈଠକ ଏଠାରେ ଦେଖାଯିବ।',
    announcements: 'ଘୋଷଣାବଳୀ',
    noAnnouncements: 'କୌଣସି ଘୋଷଣା ନାହିଁ',
    noAnnouncementsDesc: 'ପ୍ରକାଶିତ ନୋଟିସ୍ ଏଠାରେ ପ୍ରଦର୍ଶିତ ହେବ।',
    recentActivity: 'ସାମ୍ପ୍ରତିକ କାର୍ଯ୍ୟକଳାପ',
    noActivity: 'ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି କାର୍ଯ୍ୟକଳାପ ନାହିଁ',
    noActivityDesc: 'ସୂଚନା ଏବଂ ଅପଡେଟ୍ ଏଠାରେ ଦେଖାଯିବ।',
    recentTransactions: 'ସାମ୍ପ୍ରତିକ କାରବାର',
    visitorActivity: 'ଦର୍ଶକ କାର୍ଯ୍ୟକଳାପ',
    visitorsComingSoon: 'ଦର୍ଶକ ମଡ୍ୟୁଲ୍ ଶୀଘ୍ର ଆସୁଛି',
    visitorsComingSoonDesc: 'ଦର୍ଶକ ମଡ୍ୟୁଲ୍ ସକ୍ରିୟ ହେଲେ ଗେଟ୍ ଲଗ୍ ଏଠାରେ ଦେଖାଯିବ।',
    openVisitors: 'ଦର୍ଶକ ଖୋଲନ୍ତୁ',
    recentNotices: 'ସାମ୍ପ୍ରତିକ ନୋଟିସ୍',
    pendingComplaints: 'ବକେୟା ଅଭିଯୋଗ',
    upcomingEvents: 'ଆଗାମୀ କାର୍ଯ୍ୟକ୍ରମ',
    maintenanceDue: 'ରକ୍ଷଣାବେକ୍ଷଣ ବକେୟା',
    visitorsToday: 'ଆଜିର ଆଗନ୍ତୁକ',
    viewAll: 'ସବୁ ଦେଖନ୍ତୁ',
    societyOverview: 'ସୋସାଇଟି ସମୀକ୍ଷା',
    activeNotices: 'ସକ୍ରିୟ ନୋଟିସ୍',
  },
  complaints: {
    title: 'ହେଲ୍ପଡେସ୍କ ଏବଂ ଅଭିଯୋଗ',
    createComplaint: 'ଅଭିଯୋଗ ଦାଖଲ କରନ୍ତୁ',
    category: 'ବିଭାଗ',
    priority: 'ପ୍ରାଥମିକତା',
    status: 'ସ୍ଥିତି',
    description: 'ବିବରଣୀ',
    raisedBy: 'ଦାଖଲକାରୀ',
    assignedTo: 'ନ୍ୟସ୍ତ କରାଯାଇଛି',
    resolve: 'ସମାଧାନ ଚିହ୍ନିତ କରନ୍ତୁ',
    myComplaints: 'ମୋର ଅଭିଯୋଗ',
    allComplaints: 'ସମସ୍ତ ସୋସାଇଟି ଅଭିଯୋଗ',
  },
  visitors: {
    title: 'ଆଗନ୍ତୁକ ପରିଚାଳନା',
    logVisitor: 'ଅତିଥିଙ୍କୁ ପୂର୍ବ-ଅନୁମତି ଦିଅନ୍ତୁ',
    visitorName: 'ଅତିଥିଙ୍କ ନାମ',
    phone: 'ଫୋନ୍ ନମ୍ବର',
    hostUnit: 'ଫ୍ଲାଟ୍ / ୟୁନିଟ୍',
    purpose: 'ଆସିବାର ଉଦ୍ଦେଶ୍ୟ',
    vehicleNumber: 'ଗାଡ଼ି ନମ୍ବର',
    checkIn: 'ଚେକ୍-ଇନ୍',
    checkOut: 'ଚେକ୍-ଆଉଟ୍',
    expectedVisitors: 'ଆସିବାକୁ ଥିବା ଅତିଥି',
    activeVisitors: 'ବର୍ତ୍ତମାନ ଭିତରେ ଥିବା ଅତିଥି',
  },
  finance: {
    title: 'ଆର୍ଥିକ ଓ ଦେୟ',
    dues: 'ଦେୟ ବକେୟା',
    payNow: 'ବର୍ତ୍ତମାନ ପୈଠ କରନ୍ତୁ',
    transactions: 'କାରବାର ଇତିହାସ',
    invoices: 'ରକ୍ଷଣାବେକ୍ଷଣ ବିଲ୍',
    receipts: 'ଦେୟ ରସିଦ',
    paymentHistory: 'ଦେୟ ଇତିହାସ',
    maintenanceFee: 'ମାସିକ ରକ୍ଷଣାବେକ୍ଷଣ ଫି',
    outstandingBalance: 'ମୋଟ ବକେୟା',
    paid: 'ପୈଠ ହୋଇଛି',
    unpaid: 'ପୈଠ ହୋଇନାହିଁ',
  },
  notices: {
    title: 'ସୋସାଇଟି ବିଜ୍ଞପ୍ତି',
    createNotice: 'ନୋଟିସ୍ ପ୍ରକାଶ କରନ୍ତୁ',
    important: 'ଜରୁରୀ ନୋଟିସ୍',
    publishedOn: 'ପ୍ରକାଶନ ତାରିଖ',
    readMore: 'ସମ୍ପୂର୍ଣ୍ଣ ପଢ଼ନ୍ତୁ',
    attachments: 'ସଂଲଗ୍ନ ଦସ୍ତାବିଜ୍',
    societyAnnouncements: 'ସାମୂହିକ ଘୋଷଣା',
  },
  amenities: {
    title: 'ସୁବିଧା ସୁଯୋଗ',
    bookAmenity: 'ସୁବିଧା ବୁକ୍ କରନ୍ତୁ',
    myBookings: 'ମୋର ବୁକିଂ',
    availableSlots: 'ଉପଲବ୍ଧ ସମୟ',
    rules: 'ନିୟମାବଳୀ',
  },
  elections: {
    title: 'ନିର୍ବାଚନ ଓ ଭୋଟିଂ',
    activeElections: 'ସକ୍ରିୟ ନିର୍ବାଚନ',
    castVote: 'ଆପଣଙ୍କର ଭୋଟ ଦିଅନ୍ତୁ',
    candidates: 'ପ୍ରାର୍ଥୀ ତାଲିକା',
    results: 'ନିର୍ବାଚନ ଫଳାଫଳ',
  },
  emergency: {
    emergencyAlert: 'ଜରୁରୀକାଳୀନ ସତର୍କତା (EMERGENCY)',
    triggerAlert: 'ଏସଓଏସ ଚେତାବନୀ ପଠାନ୍ତୁ',
    fire: 'ଅଗ୍ନିକାଣ୍ଡ ଜରୁରୀକାଳୀନ',
    medical: 'ଡାକ୍ତରୀ ଜରୁରୀକାଳୀନ',
    security: 'ସୁରକ୍ଷା ବିପଦ',
    panic: 'ପ୍ୟାନିକ୍ ବଟନ୍',
    sos: 'ଏସଓଏସ ପ୍ରସାରଣ',
    activeAlert: 'ଜରୁରୀକାଳୀନ ଆଲର୍ଟ ଜାରି ରହିଛି',
  },
  validation: {
    required: 'ଏହି ତଥ୍ୟ ଆବଶ୍ୟକ।',
    invalidEmail: 'ଦୟାକରି ଏକ ବୈଧ ଇମେଲ୍ ଠିକଣା ପ୍ରବେଶ କରନ୍ତୁ।',
    invalidMobile: 'ଦୟାକରି ଏକ ବୈଧ ୧୦-ଅଙ୍କ ବିଶିଷ୍ଟ ମୋବାଇଲ୍ ନମ୍ବର ଦିଅନ୍ତୁ।',
    passwordTooShort: 'ପାସୱାର୍ଡ ଅତି କମରେ ୮ଟି ଅକ୍ଷର ହେବା ଆବଶ୍ୟକ।',
    positiveNumber: 'ଦୟାକରି ଏକ ସକାରାତ୍ମକ ମୂଲ୍ୟ ଦିଅନ୍ତୁ।',
  },
  superAdmin: {
    title: 'ପ୍ଲାଟଫର୍ମ ପ୍ରଶାସନ',
    dashboard: 'ଡ୍ୟାସବୋର୍ଡ',
    platformOverview: 'ପ୍ଲାଟଫର୍ମ ଅବଲୋକନ',
    platformOverviewSubtitle: 'ବାସ୍ତବ-ସମୟ ବହୁ-ଭଡ଼ାଟିଆ ସୋସାଇଟି ପରିସଂଖ୍ୟାନ, ସଦସ୍ୟତା ସ୍ଥିତି, ଏବଂ ପ୍ଲାଟଫର୍ମ କାର୍ଯ୍ୟକଳାପ',
    totalSocieties: 'ମୋଟ ସୋସାଇଟି',
    societiesActiveAndTrial: '{{active}} ସକ୍ରିୟ · {{trial}} ପରୀକ୍ଷାମୂଳକ',
    monthlyRecurring: 'ମାସିକ ଆବୃତ୍ତି ରାଜସ୍ୱ (MRR)',
    annualRecurring: 'ବାର୍ଷିକ ARR: {{arr}}',
    activeTrials: 'ସକ୍ରିୟ ଟ୍ରାଏଲ୍',
    expiringInDays: '୩୦ ଦିନରେ {{count}} ମିଆଦ ସରୁଛି',
    totalPlatformUsers: 'ମୋଟ ପ୍ଲାଟଫର୍ମ ଉପଭୋକ୍ତା',
    acrossAllManagedSocieties: 'ସମସ୍ତ ପରିଚାଳିତ ସୋସାଇଟିରେ',
    upcomingExpirations: 'ଆଗାମୀ ଟ୍ରାଏଲ୍ ଓ ଲାଇସେନ୍ସ ସମାପ୍ତି (ଆଗାମୀ ୩୦ ଦିନ)',
    upcomingExpirationsSubtitle: 'ଟ୍ରାଏଲ୍ ବୃଦ୍ଧି, ନବୀକରଣ କିମ୍ବା ରୂପାନ୍ତର ଆବଶ୍ୟକ କରୁଥିବା ସୋସାଇଟିଗୁଡ଼ିକ',
    noUpcomingExpirations: 'ଆଗାମୀ ୩୦ ଦିନରେ କୌଣସି ସୋସାଇଟି ଲାଇସେନ୍ସ ସମାପ୍ତି ନାହିଁ।',
    societyName: 'ସୋସାଇଟି ନାମ',
    plan: 'ପ୍ଲାନ୍',
    expiresIn: 'ମିଆଦ ସମାପ୍ତି',
    manage: 'ପରିଚାଳନା',
    subscriptionTierShare: 'ସଦସ୍ୟତା ପ୍ଲାନ୍ ଅଂଶ',
    subscriptionTierShareSubtitle: 'ପ୍ଲାନ୍ ଅନୁସାରେ ସକ୍ରିୟ ସୋସାଇଟି ବଣ୍ଟନ',
    noPlanDistribution: 'କୌଣସି ପ୍ଲାନ୍ ବଣ୍ଟନ ତଥ୍ୟ ଉପଲବ୍ଧ ନାହିଁ',
    daysCount: '{{count}} ଦିନ',
    expiredToday: 'ଆଜି ମିଆଦ ପୂର୍ଣ୍ଣ',
    freeTrial: 'ମାଗଣା ଟ୍ରାଏଲ୍',
    analytics: 'ପ୍ଲାଟଫର୍ମ ବିଶ୍ଳେଷଣ',
    societies: 'ସମସ୍ତ ସୋସାଇଟି',
    societyTypes: 'ସୋସାଇଟି ପ୍ରକାର',
    trials: 'ମାଗଣା ପରୀକ୍ଷଣ ଏବଂ ଅନବୋର୍ଡିଂ',
    subscriptions: 'ସଦସ୍ୟତା',
    licenses: 'ସଫ୍ଟୱେୟାର ଲାଇସେନ୍ସ',
    plans: 'ସଦସ୍ୟତା ଯୋଜନା',
    invoices: 'ବିଲିଂ ଏବଂ ଇନଭଏସ୍',
    pricingOverrides: 'ମୂଲ୍ୟ ପରିବର୍ତ୍ତନ',
    coupons: 'କୁପନ୍ ଏବଂ ରିହାତି',
    promotion: 'ପ୍ରଗତି ଏବଂ ପ୍ରଚାର',
    referrals: 'ସହଯୋଗୀ ଏବଂ ରେଫରାଲ୍',
    marketing: 'ମାର୍କେଟିଂ କର୍ମଚାରୀ',
    websiteCms: 'ୱେବସାଇଟ୍ ସିଏମଏସ୍ ଏବଂ ବ୍ରାଣ୍ଡିଂ',
    features: 'ଫିଚର୍ ଫ୍ଲାଗ୍',
    platformUsers: 'ପ୍ଲାଟଫର୍ମ ପ୍ରଶାସକ',
    systemHealth: 'ସିଷ୍ଟମ୍ ସ୍ୱାସ୍ଥ୍ୟ',
    auditLogs: 'ଅଡିଟ୍ ଲଗ୍',
    settings: 'ଗ୍ଲୋବାଲ୍ ସେଟିଙ୍ଗ୍',
    dataCleanup: 'ତଥ୍ୟ ସଫା କରିବା',
    maintenance: 'ଡାଟାବେସ୍ ରକ୍ଷଣାବେକ୍ଷଣ',
  },
  tables: {
    noRecords: 'କୌଣସି ତଥ୍ୟ ମିଳିଲା ନାହିଁ',
    rowsPerPage: 'ପୃଷ୍ଠା ପ୍ରତି ଧାଡ଼ି:',
    pageOf: 'ପୃଷ୍ଠା {{page}} / {{totalPages}}',
    filterResults: 'ଫଳାଫଳ ଫିଲ୍ଟର୍ କରନ୍ତୁ...',
    showingResults: 'ସମୁଦାୟ {{count}} ଫଳାଫଳ ଦେଖାଯାଉଛି',
  },
  dialogs: {
    confirmAction: 'କାର୍ଯ୍ୟାନୁଷ୍ଠାନ ନିଶ୍ଚିତ କରନ୍ତୁ',
    confirmDelete: 'ଡିଲିଟ୍ ନିଶ୍ଚିତ କରନ୍ତୁ',
    areYouSure: 'ଆପଣ ନିଶ୍ଚିତ ଭାବରେ ଆଗକୁ ବଢ଼ିବାକୁ ଚାହାଁନ୍ତି କି?',
    irreversibleNotice: 'ଏହି ପଦକ୍ଷେପ ପୂର୍ବାବସ୍ଥାକୁ ଫେରାଇ ହେବ ନାହିଁ।',
    discardChanges: 'ଅସଂରକ୍ଷିତ ପରିବର୍ତ୍ତନଗୁଡ଼ିକୁ ବାତିଲ କରିବେ କି?',
  },
  feedback: {
    savedSuccess: 'ବିବରଣୀ ସଫଳତାର ସହିତ ସାଇତାଗଲା',
    updateSuccess: 'ସଫଳତାର ସହିତ ଅପଡେଟ୍ ହେଲା',
    errorOccurred: 'ତ୍ରୁଟି ଘଟିଛି। ଦୟାକରି ପୁନର୍ବାର ଚେଷ୍ଟା କରନ୍ତୁ।',
    languageChanged: 'ଭାଷା ଓଡ଼ିଆକୁ ପରିବର୍ତ୍ତିତ ହେଲା',
    biometricEnabledSuccess: 'ବାୟୋମେଟ୍ରିକ୍ ସୁରକ୍ଷା ସକ୍ଷମ ହୋଇଛି',
    biometricDisabledSuccess: 'ବାୟୋମେଟ୍ରିକ୍ ସୁରକ୍ଷା ନିଷ୍କ୍ରିୟ ହୋଇଛି',
  },
};
